import * as React from 'react'
import { css } from '@emotion/react'
import { Card, colors, Divider, font, mq } from 'plume-ui'
import { ExternalNews } from '../../../types'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { EmptyCard } from '../../common/EmptyCard'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  list: ExternalNews[]
}

const defaultImg = '/static/images/no-image.png'

export const ExternalNewsList: React.FC<Props> = (props) => {
  return (
    <Card
      css={css`
        margin-block-start: 16px;
        ${mq.large} {
          margin-block-start: 24px;
        }
      `}
    >
      <CardInnerTitle title="外部ニュース" />
      {props.list.length > 0 ? (
        props.list.map((n, i) => {
          return (
            <React.Fragment key={i}>
              <Card.Content>
                <div
                  css={css`
                    display: flex;
                    flex-direction: row-reverse;
                    grid-gap: 16px;
                    ${mq.large} {
                      flex-direction: row;
                    }
                  `}
                >
                  <div
                    css={css`
                      flex-basis: 112px;
                      ${mq.large} {
                        flex-basis: 144px;
                      }
                    `}
                  >
                    <a
                      href={n.url}
                      target="_blank"
                      css={css`
                        display: block;
                        position: relative;
                        border-radius: 2px;
                        &::before {
                          content: '';
                          display: block;
                          width: 100%;
                          height: 100%;
                          background-color: transparent;
                          border-radius: 2px;
                          position: absolute;
                          transition: background-color 0.2s ease;
                        }
                        &:hover::before {
                          background-color: rgba(0, 0, 0, 0.08);
                        }
                      `}
                    >
                      <img
                        src={n.imageUrl || defaultImg}
                        alt={n.title}
                        css={css`
                          display: block;
                          object-fit: contain;
                          width: 112px;
                          aspect-ratio: 1.91 / 1;
                          border-radius: 2px;
                          ${mq.large} {
                            width: 144px;
                          }
                        `}
                      />
                    </a>
                  </div>
                  <div
                    css={css`
                      flex: 1;
                    `}
                  >
                    <a
                      href={n.url}
                      target="_blank"
                      css={css`
                        display: inline-block;
                        color: ${colors.black10};
                      `}
                    >
                      <span
                        css={css`
                          font-size: 14px;
                          line-height: 1.5;
                          font-weight: ${font.weight.bold};
                          text-decoration: underline solid transparent;
                          transition: text-decoration 0.2s ease 0s;
                          &:hover {
                            text-decoration: underline solid Currentcolor;
                          }
                        `}
                      >
                        {n.title}
                      </span>
                    </a>
                    <div
                      css={css`
                        margin-top: 4px;
                        color: ${colors.textLight};
                        font-size: 12px;
                      `}
                    >
                      <FormattedDate>{n.publishedAt}</FormattedDate>
                    </div>
                  </div>
                </div>
              </Card.Content>
              <Divider />
            </React.Fragment>
          )
        })
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
